import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { newsApi } from '../utils/api';
import PageHeader from '../components/common/PageHeader';
import ViewToggle from '../components/common/ViewToggle';
import NewsList from '../components/common/NewsList';
import LatestNews from '../components/common/LatestNews';
import AdBanner from '../components/common/AdBanner';
import PageLoader from '../components/common/PageLoader';

// API response hamesha array huna sakdaina — crash huna na deuna
const toArray = (v) => (Array.isArray(v) ? v : []);

function NewsPage({ onOpen }) {
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [view, setView] = useState('grid');
  const lastNoResult = useRef('');

  useEffect(() => {
    fetchNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, q]);

  const fetchNews = async () => {
    setLoading(true);
    try {
      if (q) {
        // Server-side search across ALL news (title, subtitle, excerpt, content)
        const response = await newsApi.getAll({ q, limit: 500 });
        const list = toArray(response.data) || [];
        setNews(list);
        setTotalPages(1);
        // Natija nabhaye toast (page bhitra message dekhaudaina)
        if (list.length === 0 && lastNoResult.current !== q) {
          lastNoResult.current = q;
          toast.error(`«${q}» — कुनै समाचार फेला परेन।`);
        }
      } else {
        const response = await newsApi.getAll({ limit: 12, page });
        const list = toArray(response.data) || [];
        setNews(list);
        setTotalPages(Math.ceil(list.length / 12) || 1);
      }
    } catch (error) {
      console.error('Error fetching news:', error);
      setNews([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <main className="max-w-[1240px] mx-auto px-5 pt-7 w-full">
        <PageLoader />
      </main>
    );
  }

  return (
    <main className="max-w-[1240px] mx-auto px-5 pt-7 pb-[60px] w-full">
      <PageHeader
        title={q ? `खोज: "${q}"` : 'सबै समाचार'}
        subtitle="देश र विदेशका ताजा तथा विश्वसनीय समाचारहरू एकै ठाउँमा।"
        crumbs={q ? ['गृहपृष्ठ', 'सबै समाचार', `खोज: "${q}"`] : ['गृहपृष्ठ', 'सबै समाचार']}
      />

      <div className="flex items-center justify-end gap-4 mb-6">
        <ViewToggle view={view} onChange={setView} />
      </div>

      <div className="grid gap-8 lg:grid-cols-[1fr_340px] items-start">
        <div className="min-w-0">
          <NewsList news={news} view={view} onOpen={onOpen} />

          {totalPages > 1 && (
            <div className="flex items-center justify-center gap-4 py-6">
              <button
                className="px-4 py-2 rounded-full border border-line text-[13px] font-semibold text-ink-soft hover:bg-paper-soft disabled:opacity-40 disabled:cursor-not-allowed"
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
              >
                अघिल्लो
              </button>
              <span className="text-[13px] font-semibold text-muted">{page} / {totalPages}</span>
              <button
                className="px-4 py-2 rounded-full border border-line text-[13px] font-semibold text-ink-soft hover:bg-paper-soft disabled:opacity-40 disabled:cursor-not-allowed"
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              >
                पछिल्लो
              </button>
            </div>
          )}

        </div>

        <aside className="flex flex-col gap-6 lg:sticky lg:top-24 min-w-0">
          <LatestNews items={news} onOpen={onOpen} />
          <AdBanner position="sidebar" />
        </aside>
      </div>
    </main>
  );
}

export default NewsPage;